import React from "react";
import { Link } from "react-router-dom";
import aboutImg from "../assets/images/privix-phone.png"
import {FiShieldOff, FiCloud, FiDollarSign} from '../assets/icons/vander'

export default function AboutOne(){
    return(
        <>
        <div className="container relative md:mt-24 mt-16">
            <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-6">
                <div className="relative overflow-hidden rounded-lg border border-amber-400/5 bg-gradient-to-tl to-amber-400/30 from-fuchsia-600/30 dark:to-amber-400/50 dark:from-fuchsia-600/50 ps-6 pt-6 lg:me-8">
                    <img src={aboutImg} className="ltr:rounded-tl-lg rtl:rounded-tr-lg transform hover:scale-105 transition-transform duration-500" alt=""/>
                </div>

                <div className="space-y-6">
                    <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Why Your AI Solution Needs a <br/> <span className="bg-gradient-to-br from-amber-400 to-fuchsia-600 text-transparent bg-clip-text">Privacy-First Approach</span></h3>
                    
                    <p className="text-slate-400 max-w-xl">In today's data-driven world, traditional cloud-based AI solutions pose significant risks. Your sensitive data shouldn't be exposed just to leverage AI capabilities.</p>

                    <div className="grid grid-cols-1 gap-4">
                        <div className="flex items-start gap-3">
                            <div className="min-w-[40px] h-10 w-10 flex items-center justify-center bg-amber-400/5 dark:bg-amber-400/10 text-amber-400 rounded-lg">
                                <FiShieldOff className="h-5 w-5"/>
                            </div>
                            <div>
                                <h5 className="text-lg font-semibold mb-1">Data Privacy Risks</h5>
                                <p className="text-slate-400">Cloud AI services can expose your confidential information to third parties</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-3">
                            <div className="min-w-[40px] h-10 w-10 flex items-center justify-center bg-amber-400/5 dark:bg-amber-400/10 text-amber-400 rounded-lg">
                                <FiCloud className="h-5 w-5"/>
                            </div>
                            <div>
                                <h5 className="text-lg font-semibold mb-1">Vendor Lock-in</h5>
                                <p className="text-slate-400">Dependency on cloud providers limits your control and flexibility</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-3">
                            <div className="min-w-[40px] h-10 w-10 flex items-center justify-center bg-amber-400/5 dark:bg-amber-400/10 text-amber-400 rounded-lg">
                                <FiDollarSign className="h-5 w-5"/>
                            </div>
                            <div>
                                <h5 className="text-lg font-semibold mb-1">Unpredictable Costs</h5>
                                <p className="text-slate-400">Pay-per-token pricing can lead to escalating expenses</p>
                            </div>
                        </div>
                    </div>
{/* 
                    <div className="flex items-center gap-2 pt-4">
                        <FiShield className="h-5 w-5 text-amber-400"/>
                        <p className="text-slate-400 italic">Privix.ai: Where your data stays yours, and AI works for you, not the other way around.</p>
                    </div> */}

                    <div className="mt-4">
                        <Link to="/contact" className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-amber-400 hover:bg-amber-500 border-amber-400 hover:border-amber-500 text-white rounded-md">Learn More About Our Approach</Link>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}